<template>
  <v-app>
    <v-app-bar app color="white" height="100">
      <nuxt-link to="/">
        <v-avatar class="mr-3" color="grey lighten-5" size="70">
          <v-img contain :src="'customers/' + customer + '/logo.png'" />
        </v-avatar>
      </nuxt-link>

      <v-toolbar-title class="font-weight-black headline">
        {{ title }}
      </v-toolbar-title>

      <v-spacer />
      <client-only>
        <v-btn
          v-if="$auth.user"
          class="ml-4 font-weight-black"
          text
          nuxt
          to="/apps"
        >
          {{ $t("apps") }}
        </v-btn>
        <v-btn
          v-if="!$auth.user"
          class="ml-4 font-weight-black"
          text
          nuxt
          to="login"
        >
          {{ $t("login") }}
        </v-btn>
        <v-btn
          v-else
          class="ml-4 font-weight-black"
          text
          @click="$auth.logout()"
        >
          {{ $t("logout") }}
        </v-btn>
      </client-only>
    </v-app-bar>

    <v-main>
      <nuxt />
    </v-main>
    <component :is="footer" />
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";

export default {
  components: { Snackbar },
  data({ $config }) {
    return {
      footer: () =>
        import(
          /* webpackChunkName: "home" */ "@/components/bycustomer/footer/" +
            $config.CUSTOMER +
            ".vue"
        ), // interpolation evades warnings
      title: $config.PAGE_TITLE || $config.CUSTOMER.toUpperCase(),
      customer: $config.CUSTOMER,
    };
  },
};
</script>
